<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain rodape>
      <section>
        <h1
          class="primary--text headline pt-8"
        >
          Ops! Página não encontrada.
        </h1>

        <v-img
          alt="Imagem ilustrativa para página não encontrada."
          src="~@/assets/img/erro404.svg"
          height="163"
          width="267"
          class="mt-5"
        />

        <div>
          <p
            class="primary--text font-weight-bold mt-5"
          >
            Entenda o que pode ter acontecido:
          </p>

          <ul class="primary--text">
            <li>
              O conteúdo que você procura pode ter sido removido ou estar temporariamente
              indisponível.
            </li>
            <li>Verifique se você digitou corretamente o endereço desejado.</li>
          </ul>
        </div>

        <v-btn
          href="/"
          outlined
          color="primary"
          class="mt-8"
          width="295"
          data-cy="button_ir_pagina_inicial"
        >
          Voltar à página inicial
        </v-btn>
      </section>
    </InternaMain>
    <Rodape />
  </Wrapper>
</template>

<script>

import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import Rodape from '@/components/Rodape.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';

export default {
  name: 'Error404',

  components: {
    Wrapper,
    Topo,
    Rodape,
    MenuLateral,
    InternaMain,
  },

};
</script>
